import { INotification } from "@Store/types"

export class Notification {
    public static getNotification(notif: INotification | string): INotification {
        if (typeof notif !== 'string') return notif

        let notification: INotification = { message: notif, actions: [], delay: false, canClose: true }
        return notification
    }
}